import { Col, Row } from "antd";
import styled from "styled-components";

import { fontSizes } from "../../shared/styles/typography";

export const StyledFooter = styled.footer`
  width: 100%;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.primaryDarker},
    ${({ theme }) => theme.colors.primary}
  );
  color: ${({ theme }) => theme.colors.titleOnPrimary};
  margin-top: auto;
`;

export const StyledFooterInner = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.layout.headerFooterInnerMaxPx}px;
  margin: 0 auto;
  padding: 2rem max(1.2rem, env(safe-area-inset-left)) 2rem
    max(1.2rem, env(safe-area-inset-right));
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 2.4rem 1.6rem 2rem;
  }
`;

export const StyledFooterTopRow = styled(Row)`
  row-gap: 1.6rem;
`;

export const StyledBrandCol = styled(Col)`
  && {
    display: flex;
    align-items: center;
  }
`;

export const StyledInfoCol = styled(Col)`
  && {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  @media (min-width: 768px) {
    && {
      justify-content: flex-end;
      text-align: right;
    }
  }
`;

export const StyledBrand = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const StyledLogo = styled.img`
  height: 3.2rem;
  object-fit: contain;
`;

export const StyledBrandText = styled.div`
  span {
    display: block;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    font-size: ${fontSizes.base}px;
  }

  small {
    display: block;
    font-size: ${fontSizes.sm}px;
    opacity: 0.85;
  }
`;

export const StyledInfo = styled.span`
  display: block;
  font-size: ${fontSizes.sm}px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.9);
  text-align: left;

  @media (min-width: 768px) {
    text-align: right;
  }
`;

export const StyledFooterBottomRow = styled(Row)`
  margin-top: 1.6rem;
  padding-top: 1.4rem;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  flex-direction: column;
`;

export const StyledCopyright = styled.span`
  font-size: ${fontSizes.sm}px;
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
`;

export const StyledAdSlot = styled.div`
  margin: ${({ theme }) => theme.spacing.footerAdMarginY} 0;
`;
